const itiTenants = [
  'TN-9777ef45-ba68-4a52-b4f0-5e85b190cc25', // EXT
  'TN-c2fac321-6d54-4c20-acb2-fb72a212dc6e', // PROD
];

export default itiTenants;
